module.exports = __webpack_public_path__ + "static/img/7e.140da5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7e.jpg
// module id = tf//
// module chunks = 0